import React, { useContext, useEffect } from 'react'
import { FlexView, Icon, Button, Spinner } from 'components/common'
import { useTranslation } from 'react-i18next'
import { TubularContext } from 'stores/TubularStore'
import styled from 'styled-components'
import { useHistory, useParams } from 'react-router-dom'
import TimelineItem from 'components/search/TimelineItem'
import 'components/search/Timeline.css'
import { formatIppnFull } from 'utils/format'
import { UserContext } from 'stores/UserStore'

const BackButtons = styled(Button)`
  border-radius: 56%;
  width: 40px;
  height: 40px;
`
const SpanLabel = styled.span`
  border-radius: 10px;
  font-size: 20px;
  line-height: 30px;
  font-weight: bolder;
  margin: 13px 12px!important;
`
const SpanValue = styled.span`
border-radius: 10px;
margin: 15px 0px!important;
font-size: 20px;
line-height: 30px;
font-weight: bolder;
color: ${({ theme }) => theme.colors.secondary};
 margin: 13px 0px!important;
`

const Ippn = () => {
  const history = useHistory()
  const { ippnResult, setSearchResult, getIppnSearchData, setIppnId, isLoading, setValidId } = useContext(TubularContext)
  const { t } = useTranslation()
  const { registryLogOld, registryLog } = useContext(UserContext)

  const backButton = () => {
    setSearchResult(0)
    setValidId(null)
    history.goBack()
    registryLogOld('client_back', '/tlh/ippn')
    registryLog('ippn', 'navigation', 'client_back')
  }

  let { ippnId, validId } = useParams()

  useEffect(() => {
    registryLogOld('client_in', '/tlh/ippn')
    registryLog('ippn', 'navigation', 'client_in')

    const handleIdParam = () => {
      registryLogOld('getIppnSearchData', '/tlh/ippn')
      registryLog('ippn', 'navigation', 'get_ippn_search_data')
      getIppnSearchData({ type: 'ippn', value: ippnId })
    }

    handleIdParam(ippnId, validId)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ippnId, validId, history, setIppnId])

  const content = <>
    {
      isLoading ?
        <FlexView flex="1" width="100%" height="100%" alignItems="center" padding="50px" fontSize="big" fontWeight="bold" color="gray" backgroundColor="transparent">
          <Spinner />
        </FlexView>
        :
        <FlexView flexDirection='column'>
          <FlexView flexDirection='row' margin='15px 100px'>
            <BackButtons outline color="#f4f4f4" onClick={() => backButton()}>
              <Icon tooltip="Left" tooltipPosition="left" name="arrow-left" width="15px" height="15px" />
            </BackButtons>
            <SpanLabel>
              {t('tlh.ippn.ippn')}:
            </SpanLabel>
            <SpanValue>
              {formatIppnFull(ippnResult.ippn)}
            </SpanValue>
            <SpanLabel>
              {t('tlh.ippn.valid')}:
            </SpanLabel>
            <SpanValue>
              {ippnResult.valid}
            </SpanValue>
          </FlexView>
          {
            ippnResult.total > 0 ?
              <FlexView flexDirection='row' alignItems="center">
                <div className="timeline-container">
                  {ippnResult.details.map((item, idx) => (
                    <TimelineItem data={item} key={idx} />
                  ))}
                </div>
              </FlexView>
              :
              null
          }
        </FlexView>
    }
  </>
  
  return content
}

export default Ippn
